import React from 'react';
import _ from 'lodash';

import './JSportAutocompleteResult.scss';

function JSportAutocompleteResult({ label, image, brand, url }) {
    return (
        <a key={label} className='j-sport-autocomplete-result' href={url}>
            <div className='block'>
                <img src={image} className={'image autocomplete-item-image'} />
                <div className='block-text' style={{}}>
                    <strong className='block-text-brandname'>{brand}</strong>
                    <span className='title'>{label}</span>
                </div>
            </div>
        </a>
    );
}

export default JSportAutocompleteResult;
